import React from 'react';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const QuestionList = (props) => {
    return (React.createElement("div", { className: "question-list" }, props.questions.map((question, index) => (React.createElement("div", { key: index, className: "question-list__cell" },
        React.createElement("button", { key: index, className: `question-list__item${question.selected ? '--answered' : ''}${question.questionId === props.currentQuestionId ? '--selected' : ''}`, disabled: question.questionId === props.currentQuestionId, value: index, onClick: () => props.onQuestionSelect(index) }, index + 1),
        question.selected && (React.createElement(FontAwesomeIcon, { className: "font-awesome__question", icon: faSquareCheck })))))));
};
export { QuestionList };
